/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/business/__root'
import { Route as IndexRouteImport } from './routes/business/index'
import { Route as BookingsRouteImport } from './routes/business/bookings'
import { Route as ChannelsRouteImport } from './routes/business/channels'
import { Route as CheckInRouteImport } from './routes/business/check-in'
import { Route as FeaturedRouteImport } from './routes/business/featured'
import { Route as ListingsRouteImport } from './routes/business/listings'
import { Route as ProRouteImport } from './routes/business/pro'
import { Route as RatesRouteImport } from './routes/business/rates'
import { Route as ReservationsRouteImport } from './routes/business/reservations'
import { Route as ReviewsRouteImport } from './routes/business/reviews'
import { Route as SettlementRouteImport } from './routes/business/settlement'
import { Route as StatementsRouteImport } from './routes/business/statements'
import { Route as TeamRouteImport } from './routes/business/team'
import { Route as VerificationRouteImport } from './routes/business/verification'
import { Route as VerifiedBadgeRouteImport } from './routes/business/verified-badge'
import { Route as BookingsIndexRouteImport } from './routes/business/bookings.index'
import { Route as BookingsReferenceRouteImport } from './routes/business/bookings.$reference'
import { Route as BookingsArrivalsPrintRouteImport } from './routes/business/bookings.arrivals-print'
import { Route as BookingsCalendarRouteImport } from './routes/business/bookings.calendar'
import { Route as InviteAcceptRouteImport } from './routes/business/invite.accept'
import { Route as ListingsIndexRouteImport } from './routes/business/listings.index'
import { Route as RatesIndexRouteImport } from './routes/business/rates.index'
import { Route as RatesListingIdRouteImport } from './routes/business/rates.$listingId'
import { Route as SettlementIndexRouteImport } from './routes/business/settlement.index'
import { Route as SettlementVerifyRouteImport } from './routes/business/settlement.verify'
import { Route as SignInIndexRouteImport } from './routes/business/sign-in.index'
import { Route as SignInMfaRouteImport } from './routes/business/sign-in.mfa'
import { Route as SignInPasskeyRouteImport } from './routes/business/sign-in.passkey'
import { Route as StatementsIndexRouteImport } from './routes/business/statements.index'
import { Route as StatementsPeriodRouteImport } from './routes/business/statements.$period'
import { Route as BookingsReferenceIndexRouteImport } from './routes/business/bookings.$reference.index'
import { Route as BookingsReferencePrintRouteImport } from './routes/business/bookings.$reference.print'
import { Route as ListingsIdEditRouteImport } from './routes/business/listings.$id.edit'
import { Route as ListingsIdIcalRouteImport } from './routes/business/listings.$id.ical'
import { Route as StatementsPeriodIndexRouteImport } from './routes/business/statements.$period.index'
import { Route as StatementsPeriodPrintRouteImport } from './routes/business/statements.$period.print'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsRoute = BookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const ChannelsRoute = ChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckInRoute = CheckInRouteImport.update({
  id: '/check-in',
  path: '/check-in',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturedRoute = FeaturedRouteImport.update({
  id: '/featured',
  path: '/featured',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingsRoute = ListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProRoute = ProRouteImport.update({
  id: '/pro',
  path: '/pro',
  getParentRoute: () => rootRouteImport,
} as any)
const RatesRoute = RatesRouteImport.update({
  id: '/rates',
  path: '/rates',
  getParentRoute: () => rootRouteImport,
} as any)
const ReservationsRoute = ReservationsRouteImport.update({
  id: '/reservations',
  path: '/reservations',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsRoute = ReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const SettlementRoute = SettlementRouteImport.update({
  id: '/settlement',
  path: '/settlement',
  getParentRoute: () => rootRouteImport,
} as any)
const StatementsRoute = StatementsRouteImport.update({
  id: '/statements',
  path: '/statements',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const VerificationRoute = VerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifiedBadgeRoute = VerifiedBadgeRouteImport.update({
  id: '/verified-badge',
  path: '/verified-badge',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsIndexRoute = BookingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BookingsRoute,
} as any)
const BookingsReferenceRoute = BookingsReferenceRouteImport.update({
  id: '/$reference',
  path: '/$reference',
  getParentRoute: () => BookingsRoute,
} as any)
const BookingsArrivalsPrintRoute = BookingsArrivalsPrintRouteImport.update({
  id: '/arrivals-print',
  path: '/arrivals-print',
  getParentRoute: () => BookingsRoute,
} as any)
const BookingsCalendarRoute = BookingsCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => BookingsRoute,
} as any)
const InviteAcceptRoute = InviteAcceptRouteImport.update({
  id: '/invite/accept',
  path: '/invite/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingsIndexRoute = ListingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ListingsRoute,
} as any)
const RatesIndexRoute = RatesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RatesRoute,
} as any)
const RatesListingIdRoute = RatesListingIdRouteImport.update({
  id: '/$listingId',
  path: '/$listingId',
  getParentRoute: () => RatesRoute,
} as any)
const SettlementIndexRoute = SettlementIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettlementRoute,
} as any)
const SettlementVerifyRoute = SettlementVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => SettlementRoute,
} as any)
const SignInIndexRoute = SignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInMfaRoute = SignInMfaRouteImport.update({
  id: '/sign-in/mfa',
  path: '/sign-in/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInPasskeyRoute = SignInPasskeyRouteImport.update({
  id: '/sign-in/passkey',
  path: '/sign-in/passkey',
  getParentRoute: () => rootRouteImport,
} as any)
const StatementsIndexRoute = StatementsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StatementsRoute,
} as any)
const StatementsPeriodRoute = StatementsPeriodRouteImport.update({
  id: '/$period',
  path: '/$period',
  getParentRoute: () => StatementsRoute,
} as any)
const BookingsReferenceIndexRoute = BookingsReferenceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BookingsReferenceRoute,
} as any)
const BookingsReferencePrintRoute = BookingsReferencePrintRouteImport.update({
  id: '/print',
  path: '/print',
  getParentRoute: () => BookingsReferenceRoute,
} as any)
const ListingsIdEditRoute = ListingsIdEditRouteImport.update({
  id: '/$id/edit',
  path: '/$id/edit',
  getParentRoute: () => ListingsRoute,
} as any)
const ListingsIdIcalRoute = ListingsIdIcalRouteImport.update({
  id: '/$id/ical',
  path: '/$id/ical',
  getParentRoute: () => ListingsRoute,
} as any)
const StatementsPeriodIndexRoute = StatementsPeriodIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StatementsPeriodRoute,
} as any)
const StatementsPeriodPrintRoute = StatementsPeriodPrintRouteImport.update({
  id: '/print',
  path: '/print',
  getParentRoute: () => StatementsPeriodRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bookings': typeof BookingsRouteWithChildren
  '/channels': typeof ChannelsRoute
  '/check-in': typeof CheckInRoute
  '/featured': typeof FeaturedRoute
  '/listings': typeof ListingsRouteWithChildren
  '/pro': typeof ProRoute
  '/rates': typeof RatesRouteWithChildren
  '/reservations': typeof ReservationsRoute
  '/reviews': typeof ReviewsRoute
  '/settlement': typeof SettlementRouteWithChildren
  '/statements': typeof StatementsRouteWithChildren
  '/team': typeof TeamRoute
  '/verification': typeof VerificationRoute
  '/verified-badge': typeof VerifiedBadgeRoute
  '/bookings/$reference': typeof BookingsReferenceRouteWithChildren
  '/bookings/arrivals-print': typeof BookingsArrivalsPrintRoute
  '/bookings/calendar': typeof BookingsCalendarRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/rates/$listingId': typeof RatesListingIdRoute
  '/settlement/verify': typeof SettlementVerifyRoute
  '/sign-in/mfa': typeof SignInMfaRoute
  '/sign-in/passkey': typeof SignInPasskeyRoute
  '/statements/$period': typeof StatementsPeriodRouteWithChildren
  '/bookings/': typeof BookingsIndexRoute
  '/listings/': typeof ListingsIndexRoute
  '/rates/': typeof RatesIndexRoute
  '/settlement/': typeof SettlementIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/statements/': typeof StatementsIndexRoute
  '/bookings/$reference/print': typeof BookingsReferencePrintRoute
  '/listings/$id/edit': typeof ListingsIdEditRoute
  '/listings/$id/ical': typeof ListingsIdIcalRoute
  '/statements/$period/print': typeof StatementsPeriodPrintRoute
  '/bookings/$reference/': typeof BookingsReferenceIndexRoute
  '/statements/$period/': typeof StatementsPeriodIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/channels': typeof ChannelsRoute
  '/check-in': typeof CheckInRoute
  '/featured': typeof FeaturedRoute
  '/pro': typeof ProRoute
  '/reservations': typeof ReservationsRoute
  '/reviews': typeof ReviewsRoute
  '/team': typeof TeamRoute
  '/verification': typeof VerificationRoute
  '/verified-badge': typeof VerifiedBadgeRoute
  '/bookings/arrivals-print': typeof BookingsArrivalsPrintRoute
  '/bookings/calendar': typeof BookingsCalendarRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/rates/$listingId': typeof RatesListingIdRoute
  '/settlement/verify': typeof SettlementVerifyRoute
  '/sign-in/mfa': typeof SignInMfaRoute
  '/sign-in/passkey': typeof SignInPasskeyRoute
  '/bookings': typeof BookingsIndexRoute
  '/listings': typeof ListingsIndexRoute
  '/rates': typeof RatesIndexRoute
  '/settlement': typeof SettlementIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/statements': typeof StatementsIndexRoute
  '/bookings/$reference/print': typeof BookingsReferencePrintRoute
  '/listings/$id/edit': typeof ListingsIdEditRoute
  '/listings/$id/ical': typeof ListingsIdIcalRoute
  '/statements/$period/print': typeof StatementsPeriodPrintRoute
  '/bookings/$reference': typeof BookingsReferenceIndexRoute
  '/statements/$period': typeof StatementsPeriodIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bookings': typeof BookingsRouteWithChildren
  '/channels': typeof ChannelsRoute
  '/check-in': typeof CheckInRoute
  '/featured': typeof FeaturedRoute
  '/listings': typeof ListingsRouteWithChildren
  '/pro': typeof ProRoute
  '/rates': typeof RatesRouteWithChildren
  '/reservations': typeof ReservationsRoute
  '/reviews': typeof ReviewsRoute
  '/settlement': typeof SettlementRouteWithChildren
  '/statements': typeof StatementsRouteWithChildren
  '/team': typeof TeamRoute
  '/verification': typeof VerificationRoute
  '/verified-badge': typeof VerifiedBadgeRoute
  '/bookings/$reference': typeof BookingsReferenceRouteWithChildren
  '/bookings/arrivals-print': typeof BookingsArrivalsPrintRoute
  '/bookings/calendar': typeof BookingsCalendarRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/rates/$listingId': typeof RatesListingIdRoute
  '/settlement/verify': typeof SettlementVerifyRoute
  '/sign-in/mfa': typeof SignInMfaRoute
  '/sign-in/passkey': typeof SignInPasskeyRoute
  '/statements/$period': typeof StatementsPeriodRouteWithChildren
  '/bookings/': typeof BookingsIndexRoute
  '/listings/': typeof ListingsIndexRoute
  '/rates/': typeof RatesIndexRoute
  '/settlement/': typeof SettlementIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/statements/': typeof StatementsIndexRoute
  '/bookings/$reference/print': typeof BookingsReferencePrintRoute
  '/listings/$id/edit': typeof ListingsIdEditRoute
  '/listings/$id/ical': typeof ListingsIdIcalRoute
  '/statements/$period/print': typeof StatementsPeriodPrintRoute
  '/bookings/$reference/': typeof BookingsReferenceIndexRoute
  '/statements/$period/': typeof StatementsPeriodIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bookings'
    | '/channels'
    | '/check-in'
    | '/featured'
    | '/listings'
    | '/pro'
    | '/rates'
    | '/reservations'
    | '/reviews'
    | '/settlement'
    | '/statements'
    | '/team'
    | '/verification'
    | '/verified-badge'
    | '/bookings/$reference'
    | '/bookings/arrivals-print'
    | '/bookings/calendar'
    | '/invite/accept'
    | '/rates/$listingId'
    | '/settlement/verify'
    | '/sign-in/mfa'
    | '/sign-in/passkey'
    | '/statements/$period'
    | '/bookings/'
    | '/listings/'
    | '/rates/'
    | '/settlement/'
    | '/sign-in/'
    | '/statements/'
    | '/bookings/$reference/print'
    | '/listings/$id/edit'
    | '/listings/$id/ical'
    | '/statements/$period/print'
    | '/bookings/$reference/'
    | '/statements/$period/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/channels'
    | '/check-in'
    | '/featured'
    | '/pro'
    | '/reservations'
    | '/reviews'
    | '/team'
    | '/verification'
    | '/verified-badge'
    | '/bookings/arrivals-print'
    | '/bookings/calendar'
    | '/invite/accept'
    | '/rates/$listingId'
    | '/settlement/verify'
    | '/sign-in/mfa'
    | '/sign-in/passkey'
    | '/bookings'
    | '/listings'
    | '/rates'
    | '/settlement'
    | '/sign-in'
    | '/statements'
    | '/bookings/$reference/print'
    | '/listings/$id/edit'
    | '/listings/$id/ical'
    | '/statements/$period/print'
    | '/bookings/$reference'
    | '/statements/$period'
  id:
    | '__root__'
    | '/'
    | '/bookings'
    | '/channels'
    | '/check-in'
    | '/featured'
    | '/listings'
    | '/pro'
    | '/rates'
    | '/reservations'
    | '/reviews'
    | '/settlement'
    | '/statements'
    | '/team'
    | '/verification'
    | '/verified-badge'
    | '/bookings/$reference'
    | '/bookings/arrivals-print'
    | '/bookings/calendar'
    | '/invite/accept'
    | '/rates/$listingId'
    | '/settlement/verify'
    | '/sign-in/mfa'
    | '/sign-in/passkey'
    | '/statements/$period'
    | '/bookings/'
    | '/listings/'
    | '/rates/'
    | '/settlement/'
    | '/sign-in/'
    | '/statements/'
    | '/bookings/$reference/print'
    | '/listings/$id/edit'
    | '/listings/$id/ical'
    | '/statements/$period/print'
    | '/bookings/$reference/'
    | '/statements/$period/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BookingsRoute: typeof BookingsRouteWithChildren
  ChannelsRoute: typeof ChannelsRoute
  CheckInRoute: typeof CheckInRoute
  FeaturedRoute: typeof FeaturedRoute
  ListingsRoute: typeof ListingsRouteWithChildren
  ProRoute: typeof ProRoute
  RatesRoute: typeof RatesRouteWithChildren
  ReservationsRoute: typeof ReservationsRoute
  ReviewsRoute: typeof ReviewsRoute
  SettlementRoute: typeof SettlementRouteWithChildren
  StatementsRoute: typeof StatementsRouteWithChildren
  TeamRoute: typeof TeamRoute
  VerificationRoute: typeof VerificationRoute
  VerifiedBadgeRoute: typeof VerifiedBadgeRoute
  InviteAcceptRoute: typeof InviteAcceptRoute
  SignInMfaRoute: typeof SignInMfaRoute
  SignInPasskeyRoute: typeof SignInPasskeyRoute
  SignInIndexRoute: typeof SignInIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings': {
      id: '/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof BookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/channels': {
      id: '/channels'
      path: '/channels'
      fullPath: '/channels'
      preLoaderRoute: typeof ChannelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-in': {
      id: '/check-in'
      path: '/check-in'
      fullPath: '/check-in'
      preLoaderRoute: typeof CheckInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/featured': {
      id: '/featured'
      path: '/featured'
      fullPath: '/featured'
      preLoaderRoute: typeof FeaturedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listings': {
      id: '/listings'
      path: '/listings'
      fullPath: '/listings'
      preLoaderRoute: typeof ListingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pro': {
      id: '/pro'
      path: '/pro'
      fullPath: '/pro'
      preLoaderRoute: typeof ProRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rates': {
      id: '/rates'
      path: '/rates'
      fullPath: '/rates'
      preLoaderRoute: typeof RatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reservations': {
      id: '/reservations'
      path: '/reservations'
      fullPath: '/reservations'
      preLoaderRoute: typeof ReservationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews': {
      id: '/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof ReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settlement': {
      id: '/settlement'
      path: '/settlement'
      fullPath: '/settlement'
      preLoaderRoute: typeof SettlementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/statements': {
      id: '/statements'
      path: '/statements'
      fullPath: '/statements'
      preLoaderRoute: typeof StatementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verification': {
      id: '/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof VerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verified-badge': {
      id: '/verified-badge'
      path: '/verified-badge'
      fullPath: '/verified-badge'
      preLoaderRoute: typeof VerifiedBadgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings/': {
      id: '/bookings/'
      path: '/'
      fullPath: '/bookings/'
      preLoaderRoute: typeof BookingsIndexRouteImport
      parentRoute: typeof BookingsRoute
    }
    '/bookings/$reference': {
      id: '/bookings/$reference'
      path: '/$reference'
      fullPath: '/bookings/$reference'
      preLoaderRoute: typeof BookingsReferenceRouteImport
      parentRoute: typeof BookingsRoute
    }
    '/bookings/arrivals-print': {
      id: '/bookings/arrivals-print'
      path: '/arrivals-print'
      fullPath: '/bookings/arrivals-print'
      preLoaderRoute: typeof BookingsArrivalsPrintRouteImport
      parentRoute: typeof BookingsRoute
    }
    '/bookings/calendar': {
      id: '/bookings/calendar'
      path: '/calendar'
      fullPath: '/bookings/calendar'
      preLoaderRoute: typeof BookingsCalendarRouteImport
      parentRoute: typeof BookingsRoute
    }
    '/invite/accept': {
      id: '/invite/accept'
      path: '/invite/accept'
      fullPath: '/invite/accept'
      preLoaderRoute: typeof InviteAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listings/': {
      id: '/listings/'
      path: '/'
      fullPath: '/listings/'
      preLoaderRoute: typeof ListingsIndexRouteImport
      parentRoute: typeof ListingsRoute
    }
    '/rates/': {
      id: '/rates/'
      path: '/'
      fullPath: '/rates/'
      preLoaderRoute: typeof RatesIndexRouteImport
      parentRoute: typeof RatesRoute
    }
    '/rates/$listingId': {
      id: '/rates/$listingId'
      path: '/$listingId'
      fullPath: '/rates/$listingId'
      preLoaderRoute: typeof RatesListingIdRouteImport
      parentRoute: typeof RatesRoute
    }
    '/settlement/': {
      id: '/settlement/'
      path: '/'
      fullPath: '/settlement/'
      preLoaderRoute: typeof SettlementIndexRouteImport
      parentRoute: typeof SettlementRoute
    }
    '/settlement/verify': {
      id: '/settlement/verify'
      path: '/verify'
      fullPath: '/settlement/verify'
      preLoaderRoute: typeof SettlementVerifyRouteImport
      parentRoute: typeof SettlementRoute
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof SignInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/mfa': {
      id: '/sign-in/mfa'
      path: '/sign-in/mfa'
      fullPath: '/sign-in/mfa'
      preLoaderRoute: typeof SignInMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/passkey': {
      id: '/sign-in/passkey'
      path: '/sign-in/passkey'
      fullPath: '/sign-in/passkey'
      preLoaderRoute: typeof SignInPasskeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/statements/': {
      id: '/statements/'
      path: '/'
      fullPath: '/statements/'
      preLoaderRoute: typeof StatementsIndexRouteImport
      parentRoute: typeof StatementsRoute
    }
    '/statements/$period': {
      id: '/statements/$period'
      path: '/$period'
      fullPath: '/statements/$period'
      preLoaderRoute: typeof StatementsPeriodRouteImport
      parentRoute: typeof StatementsRoute
    }
    '/bookings/$reference/': {
      id: '/bookings/$reference/'
      path: '/'
      fullPath: '/bookings/$reference/'
      preLoaderRoute: typeof BookingsReferenceIndexRouteImport
      parentRoute: typeof BookingsReferenceRoute
    }
    '/bookings/$reference/print': {
      id: '/bookings/$reference/print'
      path: '/print'
      fullPath: '/bookings/$reference/print'
      preLoaderRoute: typeof BookingsReferencePrintRouteImport
      parentRoute: typeof BookingsReferenceRoute
    }
    '/listings/$id/edit': {
      id: '/listings/$id/edit'
      path: '/$id/edit'
      fullPath: '/listings/$id/edit'
      preLoaderRoute: typeof ListingsIdEditRouteImport
      parentRoute: typeof ListingsRoute
    }
    '/listings/$id/ical': {
      id: '/listings/$id/ical'
      path: '/$id/ical'
      fullPath: '/listings/$id/ical'
      preLoaderRoute: typeof ListingsIdIcalRouteImport
      parentRoute: typeof ListingsRoute
    }
    '/statements/$period/': {
      id: '/statements/$period/'
      path: '/'
      fullPath: '/statements/$period/'
      preLoaderRoute: typeof StatementsPeriodIndexRouteImport
      parentRoute: typeof StatementsPeriodRoute
    }
    '/statements/$period/print': {
      id: '/statements/$period/print'
      path: '/print'
      fullPath: '/statements/$period/print'
      preLoaderRoute: typeof StatementsPeriodPrintRouteImport
      parentRoute: typeof StatementsPeriodRoute
    }
  }
}

interface BookingsReferenceRouteChildren {
  BookingsReferencePrintRoute: typeof BookingsReferencePrintRoute
  BookingsReferenceIndexRoute: typeof BookingsReferenceIndexRoute
}

const BookingsReferenceRouteChildren: BookingsReferenceRouteChildren = {
  BookingsReferencePrintRoute: BookingsReferencePrintRoute,
  BookingsReferenceIndexRoute: BookingsReferenceIndexRoute,
}

const BookingsReferenceRouteWithChildren =
  BookingsReferenceRoute._addFileChildren(BookingsReferenceRouteChildren)

interface BookingsRouteChildren {
  BookingsReferenceRoute: typeof BookingsReferenceRouteWithChildren
  BookingsArrivalsPrintRoute: typeof BookingsArrivalsPrintRoute
  BookingsCalendarRoute: typeof BookingsCalendarRoute
  BookingsIndexRoute: typeof BookingsIndexRoute
}

const BookingsRouteChildren: BookingsRouteChildren = {
  BookingsReferenceRoute: BookingsReferenceRouteWithChildren,
  BookingsArrivalsPrintRoute: BookingsArrivalsPrintRoute,
  BookingsCalendarRoute: BookingsCalendarRoute,
  BookingsIndexRoute: BookingsIndexRoute,
}

const BookingsRouteWithChildren = BookingsRoute._addFileChildren(
  BookingsRouteChildren,
)

interface ListingsRouteChildren {
  ListingsIndexRoute: typeof ListingsIndexRoute
  ListingsIdEditRoute: typeof ListingsIdEditRoute
  ListingsIdIcalRoute: typeof ListingsIdIcalRoute
}

const ListingsRouteChildren: ListingsRouteChildren = {
  ListingsIndexRoute: ListingsIndexRoute,
  ListingsIdEditRoute: ListingsIdEditRoute,
  ListingsIdIcalRoute: ListingsIdIcalRoute,
}

const ListingsRouteWithChildren = ListingsRoute._addFileChildren(
  ListingsRouteChildren,
)

interface RatesRouteChildren {
  RatesListingIdRoute: typeof RatesListingIdRoute
  RatesIndexRoute: typeof RatesIndexRoute
}

const RatesRouteChildren: RatesRouteChildren = {
  RatesListingIdRoute: RatesListingIdRoute,
  RatesIndexRoute: RatesIndexRoute,
}

const RatesRouteWithChildren = RatesRoute._addFileChildren(RatesRouteChildren)

interface SettlementRouteChildren {
  SettlementVerifyRoute: typeof SettlementVerifyRoute
  SettlementIndexRoute: typeof SettlementIndexRoute
}

const SettlementRouteChildren: SettlementRouteChildren = {
  SettlementVerifyRoute: SettlementVerifyRoute,
  SettlementIndexRoute: SettlementIndexRoute,
}

const SettlementRouteWithChildren = SettlementRoute._addFileChildren(
  SettlementRouteChildren,
)

interface StatementsPeriodRouteChildren {
  StatementsPeriodPrintRoute: typeof StatementsPeriodPrintRoute
  StatementsPeriodIndexRoute: typeof StatementsPeriodIndexRoute
}

const StatementsPeriodRouteChildren: StatementsPeriodRouteChildren = {
  StatementsPeriodPrintRoute: StatementsPeriodPrintRoute,
  StatementsPeriodIndexRoute: StatementsPeriodIndexRoute,
}

const StatementsPeriodRouteWithChildren =
  StatementsPeriodRoute._addFileChildren(StatementsPeriodRouteChildren)

interface StatementsRouteChildren {
  StatementsPeriodRoute: typeof StatementsPeriodRouteWithChildren
  StatementsIndexRoute: typeof StatementsIndexRoute
}

const StatementsRouteChildren: StatementsRouteChildren = {
  StatementsPeriodRoute: StatementsPeriodRouteWithChildren,
  StatementsIndexRoute: StatementsIndexRoute,
}

const StatementsRouteWithChildren = StatementsRoute._addFileChildren(
  StatementsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BookingsRoute: BookingsRouteWithChildren,
  ChannelsRoute: ChannelsRoute,
  CheckInRoute: CheckInRoute,
  FeaturedRoute: FeaturedRoute,
  ListingsRoute: ListingsRouteWithChildren,
  ProRoute: ProRoute,
  RatesRoute: RatesRouteWithChildren,
  ReservationsRoute: ReservationsRoute,
  ReviewsRoute: ReviewsRoute,
  SettlementRoute: SettlementRouteWithChildren,
  StatementsRoute: StatementsRouteWithChildren,
  TeamRoute: TeamRoute,
  VerificationRoute: VerificationRoute,
  VerifiedBadgeRoute: VerifiedBadgeRoute,
  InviteAcceptRoute: InviteAcceptRoute,
  SignInMfaRoute: SignInMfaRoute,
  SignInPasskeyRoute: SignInPasskeyRoute,
  SignInIndexRoute: SignInIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
